import React from 'react'
import CommonFormHeading from '../../CommonUtils/CommonFormHeading'
import * as bie from "react-bootstrap";
import CommanLabAvailability from './CommanLabAvailability';

export default function AfflLabAvailabilityForm() {
    return (
        <>

            <CommonFormHeading heading="Remarks on Availability of Labs" />
            <bie.Container fluid className="px-1" >
                <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
                    <bie.Row className="px-2 pt-3 mb-3">
                        <CommanLabAvailability />
                    </bie.Row>
                </bie.Container>

            </bie.Container>


        </>
    )
}
